import '../sp-percentage-indicator/sp-percentage-indicator';

import {css, html, LitElement} from 'lit';
import {customElement, property} from 'lit/decorators.js';
import {SpImageRecognitionViewablePrediction} from "./sp-image-recognition";
import {when} from "lit/directives/when.js";
import {SpUiConfigService} from "../../services/sp-ui-config.service";
import {getIcon} from "../../styles/icons";

@customElement('sp-image-recognition-entry')
export class SpImageRecognitionEntry extends LitElement {
    @property({type: Object})
    viewablePrediction: SpImageRecognitionViewablePrediction;

    static styles = [
        // language=CSS
        css`
            :host {
                display: grid;
                grid-auto-flow: column;
                grid-template-columns: auto 1fr auto;
                grid-column-gap: var(--sp-default-padding);
                place-content: start;
                width: 100%;
                box-sizing: border-box;
            }
            
            sp-percentage-indicator {
                height: 3rem;
            }

            /* This is a best effort approach for legacy browsers where heights are hardcoded */
            @supports not (aspect-ratio: 1) {
                sp-percentage-indicator {
                    width: 3rem;
                }
            }
            
            .name {
                display: grid;
                grid-auto-flow: row;
            }
            
            .large {
                font-size: calc(var(--sp-font-size-default) * 1.8);
                line-height: 24px;
            }
            
            .small {
                font-size: var(--sp-font-size-default);
                line-height: 1;
            }

            .large, .small {
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }
            
            .info {
                position: relative;
                height: 3rem;
                width: 3rem;
            }
            
            sp-image {
                border-radius: 50%;
            }
        `
    ]

    protected render() {
        return html`
            <sp-percentage-indicator .percentage=${ this.viewablePrediction.probability }></sp-percentage-indicator>
            <div class="name">
                <div class="large">${ this.viewablePrediction.taxon?.label ?? this.viewablePrediction.result }</div>
                <div class="small">${ this.viewablePrediction.taxon?.taxon_name ?? this.viewablePrediction.result }</div>
            </div>
            ${ when(this.viewablePrediction.taxon?.image || this.viewablePrediction.taxon?.wikipedia, () => html`
                <div class="info" @click=${ this.openTaxonInfo }>
                    <sp-image
                            .image=${ this.viewablePrediction.taxon?.image ? `${SpUiConfigService.get('SP_WIKIMEDIA_URI')}/${encodeURI(this.viewablePrediction.taxon?.image)}?width=150px` : null }
                            .placeholderImage=${ `${SpUiConfigService.get('SP_TOPIC_ASSET_HOST')}/img/dummy.jpg` }
                            .badge=${ this.viewablePrediction.taxon?.wikipedia ? { 
                                icon: getIcon('info-circle', { color: 'grey-dark', size: 'x128' }),
                                backgroundColor: 'white' 
                            } : null }></sp-image>
                </div>`) }`;
    }

    openTaxonInfo(e: Event) {
        if (this.viewablePrediction.taxon?.wikipedia) {
            e.preventDefault();
            e.stopPropagation();
            this.dispatchEvent(new CustomEvent('taxon-info', { detail: { value: this.viewablePrediction.taxon } }));
        }
    }
}
